// These are the keys used to store the state of the evidence table in local storage
// Format: evidence-grid:ts:<context>
// 'ts' stands for table state, <context> is the context of the table

export const EvidenceTableStateKeys = {
  MAIN_EVIDENCE_TABLE: "evidence-grid:ts:main",
  CASE_EVIDENCE_TABLE: "evidence-grid:ts:case",
  CONTACT_EVIDENCE_TABLE: "evidence-grid:ts:contact",
  resolveCaseEvidenceTableStateKey: (case_id: number) =>
    `evidence-grid:ts:case:${case_id}`,
};
